import React from 'react';

//components
import BasicButton from '../BasicButton';

//interfaces
import { ICancelConfirmButtonPanel } from '../../../../interfaces/global/buttons/ButtonPanels';

//styles
import "../../../../styles/global/buttons/cancel-confirm-panel.scss";


const CancelConfirmPanel = ({ cancelContent, confirmContent, ariaLabelCancel, ariaLabelConfirm, panelClassName, confirmIsDisabled = false, onCancelClick, onConfirmClick, confirmLinkUrl, cancelLinkUrl}: ICancelConfirmButtonPanel) => {
    return (
        <div className={`cancel-confirm-panel ${panelClassName ?? ""}`} >
            <BasicButton className="button-panel-cancel cancel-button-style" content={cancelContent} ariaLabel={ariaLabelCancel} isLink={cancelLinkUrl !== undefined} linkUrl={cancelLinkUrl ?? undefined} onButtonClick={onCancelClick ?? undefined} />
            <BasicButton className="button-panel-confirm thrive-navy-style" content={confirmContent} ariaLabel={ariaLabelConfirm} isDisabled={confirmIsDisabled} isLink={confirmLinkUrl !== undefined} linkUrl={confirmLinkUrl ?? undefined} onButtonClick={onConfirmClick ?? undefined}/>
        </div>

    );
};

export default CancelConfirmPanel